export const DataNodeLevel = {
    LEVEL_ONE: 1,
    LEVEL_TWO: 2,
    LEVEL_THREE: 3
}